import { render, staticRenderFns } from "./amount-list.vue?vue&type=template&id=186a0bec&"
import script from "./amount-list.vue?vue&type=script&lang=ts&"
export * from "./amount-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports